import { createContext, useContext, useState, useEffect } from "react";
import { getCartItems, addItemToCart, removeCartItem } from "../services/CartApi";

// Create Cart Context
const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState([]);
    const user = JSON.parse(localStorage.getItem("user"));
    const cartCount = cartItems.length;

    useEffect(() => {
        fetchCart();
    }, []);

    const fetchCart = async () => {
        try {
            const response = await getCartItems(user.id);
            setCartItems(response.data);
        } catch (error) {
            console.error("Error fetching cart:", error);
        }
    };


    // Function to add item to cart and update count
    const addToCart = async (itemData) => {
        try {
            const response = await addItemToCart(itemData);
            await fetchCart();
            return { ok: true, message: "Item added to cart" };
        } catch (error) {
            console.error("Error adding to cart:", error);
            return { ok: false, message: error.response?.data?.message || "Failed to add item" };
        }
    };

    // Function to remove item from cart and update count
    const removeFromCart = async (itemId) => {
        try {
            await removeCartItem(itemId);
            await fetchCart();
            return { ok: true, message: "Item removed from cart" };
        } catch (error) {
            console.error("Error removing from cart:", error);
            return { ok: false, message: "Failed to remove item" };
        }
    };

    return (
        <CartContext.Provider value={{ cartItems, cartCount, addToCart, removeFromCart, fetchCart }}>
            {children}
        </CartContext.Provider>
    );
};

// Custom Hook for easy access
export const useCart = () => useContext(CartContext);

// Helper for Cart Booking type
export const getCartTypeFromItems = (cartItems) => {
    if (!cartItems || cartItems.length === 0) return null;

    const allTypes = cartItems.map(item => item.booking_type);
    const uniqueTypes = [...new Set(allTypes)];

    if (uniqueTypes.length === 1) return uniqueTypes[0]; // "renewal" or "nopayment"
    return "mixed";
};